export default "<div id=\"divTableChart\">\n</div>";